import { IconLib, IconMap } from '@common/components/Icon';
import { SFRPropertyInfoTag, SFRPropertyStatus } from '@services/appsync/types';

export const ROUTES = {
  accountInformation: '/account/information',
  activity: '/account/activity',
  autoInvestSchedule: '/account/auto-investment-schedule',
  bankAccounts: '/account/bank-accounts',
  checkoutCashflow: '/checkout/cashflow',
  checkoutSFR: (id: string) => `/checkout/sfr/${id}`,
  createAddress: '/create-account/address',
  createCitizenship: '/create-account/citizenship',
  createReviewCreateAccount: '/create-account/review',
  dashboard: '/',
  documents: '/account/documents',
  error: '/error',
  forbidden: '/forbidden',
  inbox: '/inbox',
  inboxAgreementAlert: '/inbox/alerts/agreement',
  inboxDwollaAlert: '/inbox/alerts/dwolla',
  inboxMessage: (id: string) => `/inbox/messages/${id}`,
  inboxVerifyEmailAlert: '/inbox/alerts/verify-email',
  offeringsCashflow: '/offerings/cashflow',
  partnerSignIn: '/partner-sign-in',
  portfolio: '/portfolio',
  profile: '/account/profile',
  properties: '/properties',
  propertyDetail: (slug: string) => `${ROUTES.properties}/${slug}`,
  resetPassword: '/signin/reset-password',
  roadmap: '/roadmap',
  signin: '/signin',
  signout: '/signout',
  signup: '/signup',
  statement: (month: string) => `/account/documents/statement/${month}`,
  verifyAccreditation: '/verify-accreditation',
  verifyEmail: '/verify-email',
  welcome: '/welcome',
};

export const PROPERTY_STATUS: Record<
  SFRPropertyStatus,
  [text: string, icon: keyof typeof IconMap, iconLib: IconLib, bgColor: string, textColor: string]
> = {
  NEW: ['New Property', 'sparkles', 'regular', 'green.500', 'white'],
  SOLD_OUT: ['Sold Out', 'tag', 'solid', 'red.300', 'white'],
};

export const PROPERTY_TAG: Record<SFRPropertyInfoTag, [text: string, icon: keyof typeof IconMap, iconLib: IconLib]> = {
  EQUITY: ['Equity Growth', 'arrow-trend-up', 'regular'],
  FEATURED: ['Featured', 'star', 'regular'],
  NEW: ['Newly Built', 'helmet-safety', 'regular'],
  TRENDING: ['Trending', 'arrow-trend-up', 'regular'],
};

export const LINKS = {
  CASH_FLOW_2022_CF1: 'https://static-files.m.concreit.com/CONCREIT+FUND+I+LLC-+FINANCIAL+STATEMENTS+5.5.2023.pdf',
  CASH_FLOW_FUND: 'https://try.concreit.com/cashflow-strategy-screen',
  DWOLLA_PRIVACY_POLICY: 'https://www.dwolla.com/legal/privacy',
  DWOLLA_TERMS_OF_SERVICE: 'https://www.dwolla.com/legal/tos',
  EFT_POLICY: 'https://concreit.com/legal/esign#eft',
  ESIGN: 'https://concreit.com/legal/esign',
  FORM_ADV_PART_2_BROCHURE: 'https://static-files.m.concreit.com/Concreit+Form+ADV+Part+2A+22020921.pdf',
  HISTORICAL_RETURNS:
    'https://clicks.concreit.com/f/a/o7mls_bpJqOYjbrSjnRcaA~~/AAQRxQA~/RgRlmKB0P0QvaHR0cHM6Ly93d3cuY29uY3JlaXQuY29tL2hpc3RvcmljYWwtcGVyZm9ybWFuY2VXA3NwY0IKY7V0G7Zj0vqFslISZXJpY2tAY29uY3JlaXQuY29tWAQAAAGw',
  INSTANT_EARN: 'https://www.concreit.com/legal/instant-earn',
  INVESTOPEDIA_PRIVATE_EQUITY: 'https://www.investopedia.com/terms/p/private-equity-real-estate.asp',
  PRIVACY_POLICY: 'https://concreit.com/legal/privacy-policy',
  PROGRAM_AGREEMENT: 'https://www.concreit.com/legal/advisory-agreement/',
  REFERRAL_PROGRAM: 'https://www.concreit.com/legal/referral-program',
  REFERRAL_TERMS: 'https://concreit.com/legal/referral-terms',
  REWARD_PROGRAM: 'https://intercom.help/concreit/en/articles/5104277-instant-earn-reward-program',
  TERMS: 'https://concreit.com/legal/terms',
  TYPEFORM_BASE: 'https://concreit.typeform.com/to/',
  WEBSITE: 'https://www.concreit.com',
  WITHDRAWAL_PROGRAM: 'https://concreit.com/legal/withdrawal-program',
};

export const SUITABILITY_LIMIT_FACTOR = 0.095;
